/**
 *
 * Banner
 *
 * UI for handling some fun events for banners
 */


const $         = require( 'jQuery' );

var Banner = function(el){
    this.$el            = $(el);
    this.$close         = this.$el.find( '.itbl-b-banner__close' );
    this.$container     = this.$el.find( '.itbl-b-banner__container' );
    this.$hiddenTitle   = $(document).find( '.itbl-b-banner__hidden-title' );
    this.$body          = $(document).find( 'body' );
    this.$hero          = $(document).find( '.itbl-c-hero' );
    this.$sticky        = $(document).find( '#sticky-nav-inner' );


    this.init();
};

Banner.prototype.init = function(){
   //events
    this.$close.on( 'click', this.event__toggleBanner.bind(this) );

    this.$hiddenTitle.on( 'click', this.event__toggleBanner.bind( this ) );

    $(window).on( 'changed.zf.mediaquery', this.event__testWindow.bind( this ) );

    this.$body.addClass( ( this.$el.is(':visible') ? 'has-banner has-banner-active' : 'has-banner' ) );


};

Banner.prototype.event__toggleBanner = function( event ){

    event.preventDefault();

    this.$el.toggleClass( 'transform-active'  );
    this.$hiddenTitle.toggleClass( 'transform-active' );
    this.$body.toggleClass( 'has-banner-active' );

};


Banner.prototype.event__testWindow = function( event, newSize, oldSize ){

    const breakpoints   = [ 'small', 'medium' ];

    if( breakpoints.includes( newSize ) ){

        this.$el.removeClass( 'transform-active'  );
        this.$hiddenTitle.removeClass( 'transform-active' );
        this.$body.removeClass( 'has-banner-active' );

    }


};


$(document).ready(function(){
    $('.itbl-b-banner').each(function(){
        new Banner(this);
    });

});
    
